import { type CompanyStore } from "services/company/companyStore";
import { IssueKey, type IssuesStore } from "services/issues/issuesStore";
import { type PricingPlanStore } from "services/pricingPlan/gb/pricingPlanStore";
import { PricingPlan } from "services/pricingPlan/pricingPlanTypes";
import { QuestionsStore } from "services/questions/questionsStore";
import { CompanyQuestion, ISSUE_FIELD_TO_QUESTION, QUESTION_TO_PRODUCT } from "./companyConstants";

const SKIP_QUESTIONS = new Set<CompanyQuestion>([
  CompanyQuestion.VatRegistration,
  CompanyQuestion.ConfirmationStatement,
  CompanyQuestion.Management,
  CompanyQuestion.CancellationCover,
  CompanyQuestion.PayeRegistration,
]);

export class CompanyQuestionsStore extends QuestionsStore<CompanyQuestion> {
  protected _issueKey = IssueKey.Company;
  protected _issueFieldsToQuestions = ISSUE_FIELD_TO_QUESTION;

  constructor(
    private readonly _companyStore: CompanyStore,
    private readonly _pricingPlanStore: PricingPlanStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(CompanyQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): CompanyQuestion | undefined {
    return undefined;
  }

  protected _shouldSkipQuestion(question: CompanyQuestion): boolean {
    if (SKIP_QUESTIONS.has(question)) {
      return true;
    }

    const product = QUESTION_TO_PRODUCT[question];

    if (product && this._pricingPlanStore.isProductIncluded(product)) {
      console.log(`Skipping question ${question} as product ${product} is included in the plan`);
      return true;
    }

    // The backend rejects +Taxes on the introducer free plan
    if (
      question === CompanyQuestion.AnnaTaxes &&
      this._companyStore.company?.pricingPlan === PricingPlan.IntroducerFreeRegistration
    ) {
      return true;
    }

    if (question === CompanyQuestion.VirtualPlanSelect) {
      return this._companyStore.skipVOBillingPeriod();
    }

    if (question === CompanyQuestion.VirtualAddressSelect) {
      return this._companyStore.skipVOAddressSelection();
    }

    return super._shouldSkipQuestion(question);
  }
}
